import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'
import { NormalizedWrapper } from '@theme'

import { config } from './config'
import {
  Wrapper,
  TextList,
  TextListNum,
  Container,
  ImageMobileWrapper,
  ImageDesktopWrapper,
  Title,
  ContainerItem,
} from './styles'

const { scopes, tools, imageDesktop, imageMobile, titleScope, titleTools } =
  config

export function ScopeOfWork() {
  return (
    <NormalizedWrapper>
      <Wrapper>
        <Container>
          <ContainerItem>
            <Title>{titleScope}</Title>
            <TextList>
              {scopes.map(scope => (
                <TextListNum key={scope}>{scope}</TextListNum>
              ))}
            </TextList>
          </ContainerItem>
          <ContainerItem>
            <Title>{titleTools}</Title>
            <TextList>
              {tools.map(tool => (
                <TextListNum key={tool}>{tool.toUpperCase()}</TextListNum>
              ))}
            </TextList>
          </ContainerItem>
          <ImageMobileWrapper>
            <ImageWithPlaceholder {...imageMobile} />
          </ImageMobileWrapper>
        </Container>
        <ImageDesktopWrapper>
          <ImageWithPlaceholder {...imageDesktop} />
        </ImageDesktopWrapper>
      </Wrapper>
    </NormalizedWrapper>
  )
}
